/** A request POCO to create a update an existing contact result. */
class UpdateContactResultRequest {
  constructor(public readonly contactId: string, public readonly payload: UpdateContactResultRequestPayload) {}
}

export class UpdateContactResultRequestPayload {
  constructor(
    public readonly id: string,
    public readonly typeId: number,
    public readonly patientId: string | null,
    public readonly appointmentId: string | null,
    public readonly leadId: string | null,
    public readonly disqualifyingReasonIds: string[] | null,
    public readonly notOfferedProcedureIds: string[] | null,
    public readonly notOfferedProcedureComments: string | null,
    public readonly shouldDeleteLead: boolean
  ) {}
}

export default UpdateContactResultRequest;
